import { Tooltip } from '@mui/material'
import React from 'react'
import SeatInfo from './SeatInfo'

const SeatDeatils = (props) => {
    const { children = <></>, obj = {}, userDetails = {}, tooltipOpen = null, setTooltipOpen = () => { }, targetRef = null } = props
    let disableTooltip = obj.ForAgentID !== userDetails?.AgentID && obj.IsBkgAvailable === 1
    let enableTooltip = obj.ForAgentID === userDetails?.AgentID && obj.IsBkgAvailable === 0
    return (
        <Tooltip
            arrow
            disablePortal
            placement="right"
            open={tooltipOpen === obj?.SeatLabel}
            onOpen={() => {
                if (enableTooltip) {
                    setTooltipOpen(obj?.SeatLabel)
                }
            }}
            onClose={() => {
                setTooltipOpen(null)
            }}
            onMouseLeave={() => {
                setTooltipOpen(null)
            }}
            disableHoverListener={disableTooltip}
            disableFocusListener={disableTooltip}
            disableTouchListener={disableTooltip}
            componentsProps={{
                arrow: {
                    sx: {
                        zIndex: 1, // Put arrow behind
                    },
                },
            }}
            PopperProps={{

                modifiers: [
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['top', 'bottom', 'left'],
                        },
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: 'viewport',
                            padding: 8,
                        },
                    },
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 0],
                        },

                    },
                    {
                        name: 'arrow',
                        options: { padding: 10 },
                    },
                ],
                sx: {
                    '& .MuiTooltip-tooltip': {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        padding: 0,
                        zIndex: 1400,
                    },
                    '& .MuiTooltip-arrow': {
                        color: '#FAF9F6',
                    },
                    '&[data-popper-placement^="bottom"] .MuiTooltip-arrow': {
                        color: '#0086FF',
                    },
                },
            }}

            title={<SeatInfo data={obj} targetRef={targetRef} />}
        >

            <span>{children}</span>
        </Tooltip>
    )
}

export default SeatDeatils